import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import styles from '../index.module.sass';

//Custom
// import deptosArray from './deptos.js';
// import subDeptosArray from './subdeptos.js';
// import deptosArrayMX from './deptosMX.js';
// import subDeptosArrayMX from './subdeptosMX.js';

//Dependencies
import superagent from 'superagent';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Alert from '../../Alert';

// const deptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && deptosArrayMX) || deptosArray;
// const subDeptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && subDeptosArrayMX) || subDeptosArray;

/*const initObject = {
  accion: '',
  clave: '',
  producto: '',
  precio: '',
  descripcion: '',
  aplicacion: '',
  ingredientes: '',
  familiaOlfativa: '',
  perfumista: '',
  link: '',
  departamento: '',
  subdepartamento: '',
  marca: '',
  clase: '',
  carrusel: '',
};*/

const initObject = {
  accion: '',
  codigoProducto: '',
  nombreProducto1: '',
  contenido: '',
  descripcion1: '',
  aplicacion1: '',
  ingredientes: '',
  ingredientes2: '',
  piramideOlfativa: [],
  categoria1: '',
  subCategoria1: '',
  codigoCategoria: '',
  codigoSubCategoria: '',
};

const ProductForm = (props) => {
  const { webserviceURL, history } = props;
  const [flag, setFlag] = useState(false);
  const [eventForm, setEventForm] = useState(initObject);
  const [ingredientes, setIngredientes] = useState([]);
  const { productId } = useParams();

  const [categorias, setCategorias] = useState([]);

  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  function onEditorChange(value, name) {
    setEventForm((prev) => ({
      ...prev,
      [name]: value || '',
    }));
  }

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === 'carrusel') value = value.toUpperCase();

    setEventForm({
      ...eventForm,
      [e.target.name]: value,
    });
  };

  const onSubmit = () => {
    let jsonBody = Object.assign({}, eventForm);

    const action = (productId !== 'newproduct' && 'ACTUALIZAR') || 'AGREGAR';
    jsonBody.accion = action;

    const url = `${webserviceURL}/postFichaTecnicaProducto`;

    if (jsonBody.codigoProducto.trim() === '') {
      setAlertText('Falta colocar la clave del producto');
      setOpen(true);
      return;
    }

    superagent
      .post(url)
      .set('Content-Type', 'application/json')
      .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
      .set('token', localStorage.getItem('TMBtoken'))
      .send({
        accion: action,
        idCategoria: jsonBody.codigoCategoria,
        idSubCategoria: jsonBody.codigoSubCategoria,
        idProducto: jsonBody.codigoProducto,
        descripcion1: jsonBody.descripcion1,
        descripcion2: jsonBody.descripcion2,
        aplicacion1: jsonBody.aplicacion1,
        aplicacion2: jsonBody.aplicacion2,
        recomendacion1: '',
        recomendacion2: '',
        fechaInicio: '20250101',
        fechaFin: '20501231',
        idioma: '0',
        contenidoNeto: jsonBody.contenido,
      })
      .then((res) => {
        if (res.body) {
          const { message = action, typeMessage } = res.body;

          const obtenerIngredientesDesdeHTML = (htmlEsp, htmlIng, ingredientesOriginales) => {
            const parser = new DOMParser();

            const docEsp = parser.parseFromString(htmlEsp, 'text/html');
            const docIng = parser.parseFromString(htmlIng, 'text/html');

            const itemsEsp = [...docEsp.querySelectorAll('li')];
            const itemsIng = [...docIng.querySelectorAll('li')];

            return itemsEsp.map((liEsp, index) => {
              const liIng = itemsIng[index];

              const nombre1 = liEsp.querySelector('strong')?.textContent || '';

              const ingredienteOriginal = ingredientesOriginales[index];

              return {
                idIngrediente: ingredienteOriginal?.idIngrediente || 0,

                nombre1,

                descripcion1: liEsp.textContent.replace(nombre1, '').replace(':', '').trim(),

                nombre2: liIng?.querySelector('strong')?.textContent || '',

                descripcion2: liIng?.textContent
                  .replace(liIng?.querySelector('strong')?.textContent || '', '')
                  .replace(':', '')
                  .trim(),
              };
            });
          };

          const ingredientesActualizados = obtenerIngredientesDesdeHTML(
            eventForm.ingredientes,
            eventForm.ingredientes2,
            ingredientes,
          );

          if (typeMessage === 'success') {
            /** Código para actualizar los ingredientes de los productos */
            const urlIngrediente = `${webserviceURL}/postIngredientesProducto`;
            superagent
              .post(urlIngrediente)
              .set('Content-Type', 'application/json')
              .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
              .set('token', localStorage.getItem('TMBtoken'))
              .send({
                accion: action,
                idioma: '0',
                IngregientesProducto: ingredientesActualizados.map((item) => ({
                  idProducto: jsonBody.codigoProducto,

                  idIngrediente: item.idIngrediente,

                  nombre1: item.nombre1,
                  nombre2: item.nombre2,

                  descripcion1: item.descripcion1,
                  descripcion2: item.descripcion2,
                })),
              })
              .then((res) => {
                if (res.body) {
                  console.log(res.body, 'ingredientes');

                  if (res.body.typeMessage === 'success') {
                    /** SI AMBOS SERVICIOS REGRESAN EXITOSO MANDA EL MENSAJE DE QUE SE GUARDO / ACTUALIZO */
                    window.scrollTo(0, 0);
                    setAlertText(message || action);
                    setOpen(true);
                  } else {
                    setAlertText(
                      'Ocurró un error en la carga de ingredientes, vuelva a intentarlo',
                    );
                    setOpen(true);
                  }
                }
              });

            if (action === 'AGREGAR') setEventForm(initObject);
          }
        } else {
          setAlertText('Ocurró un error, vuelva a intentarlo');
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertText('Ocurró un error');
        setOpen(true);
      });
  };

  const getProduct = useCallback(() => {
    window.scrollTo(0, 0);
    if (productId !== 'newproduct') {
      if (flag) return;
      setFlag(true);
      const url = `${webserviceURL}/GetFichaTecnicaProducto?idProducto=${productId}&idioma=0`;
      superagent
        .get(url)
        .set('Content-Type', 'application/json')
        .then((res) => {
          if (res.body) {
            setEventForm(res.body.producto);
            setIngredientes(res.body.listaIngredientes);
          } else {
            setAlertText('ocurrió un error');
            setOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (productId === 'newproduct') {
      setEventForm(initObject);
    }
  }, [webserviceURL, flag, productId]);

  // Estas categorias son las mismas que tiene el carrito
  const getCategorias = useCallback(() => {
    const urlCategorias = `${webserviceURL}/getCatalogoProductos`;
    superagent
      .get(urlCategorias)
      .set('Content-Type', 'application/json')
      .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
      .then((res) => {
        if (res.body) {
          setCategorias(res.body.categorias);
        } else {
          setAlertText('Ocurró un error al cargar las categorias, vuelva a intentarlo');
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertText('Ocurró un error al cargar las categorias');
      });
  }, [webserviceURL]);

  useEffect(() => {
    getProduct();
    getCategorias();
  }, [getProduct, getCategorias]);

  const subCategorias =
    categorias
      .find((cat) => cat.Codigo === eventForm.codigoCategoria)
      ?.subCategorias?.map((sub) => ({
        codigo: sub.Codigo,
        nombre: sub.Descripcion1,
      })) || [];

  const ingredientesHTML = `
  <ul>
    ${ingredientes
      ?.map(
        (item) =>
          `<li data-idingrediente="${item.idIngrediente}"><strong>${item.nombre1}</strong>: ${item.descripcion1}</li>`,
      )
      .join('')}
  </ul>
`;

  const ingredientesHTMLIngles = `
  <ul>
    ${ingredientes
      ?.map(
        (item) =>
          `<li data-idingrediente="${item.idIngrediente}"><strong>${item.nombre2}</strong>: ${item.descripcion2}</li>`,
      )
      .join('')}
  </ul>
`;

  useEffect(() => {
    const htmlDefault = '<ul><li><br></li></ul>';

    if (!ingredientes || ingredientes.length === 0) {
      setEventForm((prev) => ({
        ...prev,
        ingredientes: htmlDefault,
        ingredientes2: htmlDefault,
      }));

      return;
    }

    setEventForm((prev) => ({
      ...prev,
      ingredientes: ingredientesHTML,
      ingredientes2: ingredientesHTMLIngles,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ingredientes]);

  console.log(eventForm.ingredientes, 'INGREDIUENTES');

  return (
    <div className={styles.productFormContainer}>
      <Alert open={open} setOpen={setOpen} title='Mensaje del sistema' text={alertText} />
      <div>
        <div>
          <span className={styles.link} onClick={() => history.goBack()}>
            Regresar
          </span>
        </div>
      </div>

      <div className={styles.inputsContainer}>
        <div className={`${styles.three} ${styles.first}`}>
          {(productId === 'newproduct' && (
            <TextField
              onChange={handleChange}
              name='codigoProducto'
              label='Clave'
              type='text'
              value={eventForm.codigoProducto}
              variant='outlined'
              fullWidth
            />
          )) || <div className={styles.attributeName}> Clave: {eventForm.codigoProducto} </div>}
        </div>
        &nbsp;&nbsp;&nbsp;
        <div className={`${styles.three} ${styles.first}`}>
          <TextField
            onChange={handleChange}
            name='nombreProducto1'
            label='Nombre'
            type='text'
            value={eventForm.nombreProducto1}
            variant='outlined'
            fullWidth
          />
        </div>
        <div className={styles.three}>
          <TextField
            onChange={handleChange}
            name='nombreProducto2'
            placeholder='Nombre Inglés'
            type='text'
            value={eventForm.nombreProducto2}
            variant='outlined'
            fullWidth
          />
        </div>
        {/* <div className={styles.three}>
          <TextField
            onChange={handleChange}
            name='carrusel'
            placeholder='Mostrar en carrousel (S = Sí , X = No)'
            type='text'
            value={eventForm.carrusel}
            inputProps={{ maxLength: 1 }}
            variant='outlined'
            fullWidth
          />
        </div> */}
      </div>

      <div className={styles.inputsContainer}>
        <div className={`${styles.three} ${styles.first}`}>
          <FormControl variant='outlined' fullWidth>
            <InputLabel>Departamentos</InputLabel>
            <Select
              label='Departamento'
              value={eventForm.codigoCategoria}
              onChange={handleChange}
              name='codigoCategoria'>
              {categorias.map((option) => (
                <MenuItem key={option.Codigo} value={option.Codigo}>
                  {option.Descripcion1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.three}`}>
          <FormControl variant='outlined' fullWidth>
            <InputLabel>Sub departamentos</InputLabel>
            <Select
              label='Sub departamento'
              value={eventForm.codigoSubCategoria}
              onChange={handleChange}
              name='codigoSubCategoria'>
              {subCategorias.map((option) => (
                <MenuItem key={option.codigo} value={option.codigo}>
                  {option.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className={`${styles.three}`}>
          <TextField
            onChange={handleChange}
            name='contenido'
            label='Contenido neto'
            type='text'
            value={eventForm.contenido}
            variant='outlined'
            fullWidth
          />
        </div>
      </div>
      <div className={styles.attributeName}>Descripción</div>
      <div>
        <ReactQuill
          theme='snow'
          value={eventForm.descripcion1}
          onChange={(e) => onEditorChange(e, 'descripcion1')}
        />
      </div>

      <div className={styles.attributeName}>Descripción inglés</div>
      <div>
        <ReactQuill
          theme='snow'
          value={eventForm.descripcion2}
          onChange={(e) => onEditorChange(e, 'descripcion2')}
        />
      </div>

      <div>
        <div className={styles.attributeName}>Ingredientes</div>
        <ReactQuill
          theme='snow'
          value={eventForm.ingredientes || ''}
          onChange={(e) => onEditorChange(e, 'ingredientes')}
        />
      </div>

      <div>
        <div className={styles.attributeName}>Ingredientes Inglés</div>
        <ReactQuill
          theme='snow'
          value={eventForm.ingredientes2 || ''}
          onChange={(e) => onEditorChange(e, 'ingredientes2')}
        />
      </div>

      <div>
        <div className={styles.attributeName}>Aplicación</div>
        <ReactQuill
          theme='snow'
          value={eventForm.aplicacion1}
          onChange={(e) => onEditorChange(e, 'aplicacion1')}
        />
      </div>

      <div>
        <div className={styles.attributeName}>Aplicación en inglés</div>
        <ReactQuill
          theme='snow'
          value={eventForm.aplicacion2}
          onChange={(e) => onEditorChange(e, 'aplicacion2')}
        />
      </div>

      <div className={styles.buttonsContainer}>
        <Button
          type='button'
          variant='contained'
          size='large'
          color='primary'
          className={`${styles.button}`}
          onClick={(e) => {
            //if (!buttonDisabled) onSubmit(e);
            onSubmit(e);
          }}>
          Guardar
        </Button>
      </div>
    </div>
  );
};

export default ProductForm;
